import { BlogSection } from '@/types/blog';

export const naechsterSchritt: BlogSection = {
  id: 'naechster-schritt',
  title: 'Dein nächster Schritt: Finde deinen Soundtrack',
  content: `
    <p>
      Probier es aus: Wähle einen Instrumentaltrack im 60–120 BPM-Bereich, der dich sofort beruhigt und fokussiert. Lausche ihm zehn Minuten vor deiner nächsten Entscheidung. Beobachte, wie sich dein Denken klärt. Mit der Zeit entsteht dein persönlicher Soundtrack – dein Begleiter für finanzielle und persönliche Klarheit.
    </p>
    
    <blockquote class="border-l-4 border-sage-400 pl-4 italic text-joerg-700 my-6">
      „Die Musik schließt dem Menschen ein unbekanntes Reich auf, eine Welt, die nichts gemein hat mit der äußeren Sinnenwelt." — E.T.A. Hoffmann
    </blockquote>
  `
};
